import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { AlertTriangle, LogIn } from 'lucide-react'

export function ExpiredSessionScreen() {
  const navigate = useNavigate()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        padding: '24px',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          textAlign: 'center',
          maxWidth: 420,
          width: '100%',
        }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'rgba(251, 191, 36, 0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}
        >
          <AlertTriangle size={40} color="#fbbf24" />
        </motion.div>

        <h1
          style={{
            fontSize: 28,
            fontWeight: 800,
            color: '#fff',
            marginBottom: 8,
            letterSpacing: '0.01em',
          }}
        >
          Sesión Expirada
        </h1>

        <p
          style={{
            fontSize: 15,
            color: '#94a3b8',
            lineHeight: 1.6,
            marginBottom: 32,
          }}
        >
          Tu sesión ha expirado por inactividad o ingresaron en otro dispositivo. Para continuar usando la aplicación, inicia sesión nuevamente.
        </p>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => {
            localStorage.clear()
            // navigate('/auth', { replace: true })
            window.location.href = '/auth'
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            height: 48,
            padding: '0 32px',
            borderRadius: 12,
            border: 'none',
            background: 'linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)',
            color: '#fff',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(59,130,246,0.3)',
          }}
        >
          <LogIn size={18} />
          Volver a iniciar sesión
        </motion.button>
      </motion.div>
    </div>
  )
}
